import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { APP_STEPS } from "./components/config/steps";

// localStorage keys that each step expects to exist before it's "complete"
// Index 0 = Instructions, 1-6 = APP_STEPS (Personal, Academic, Financial, Documents, Statement, Review)
const STEP_KEYS = [
  [],                                      // 0: Instructions — always accessible
  ["id"],                                  // 1: Personal
  ["acedemic_detail", "marksheet"],        // 2: Academic
  ["Finance_detail"],                      // 3: Financial
  ["require_document"],                    // 4: Documents
  ["personal_statement"],                  // 5: Statement
  [],                                      // 6: Review — no key check
];

const Navbar = () => {
  const [title, setTitle] = useState("Personal Information");
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { label: "Instructions", path: "/application/instructions" },
    ...APP_STEPS.map((s) => ({ label: s.label, path: s.path })),
  ];

  // current step index (0 = Instructions, 1-5 = steps)
  const currentIndex = navItems.findIndex((n) => n.path === location.pathname);

  useEffect(() => {
    const item = navItems[currentIndex >= 0 ? currentIndex : 0];
    if (item) setTitle(item.label);
  }, [location.pathname]);

  // is this step completed (all required keys present)?
  const isComplete = (idx) => {
    if (idx <= 0) return false;
    const keys = STEP_KEYS[idx] || [];
    return keys.every((k) => {
      const v = localStorage.getItem(k);
      return v !== null && v !== "undefined" && v !== "";
    });
  };

  return (
    <nav>
      <div></div>
      <div className="mb-4">
        <div className="card text-left p-1">
          <div className="card-body p-3">
            <h4 className="card-title mb-2 d-flex align-items-center" style={{ gap: "8px" }}>
              {currentIndex > 0 && (
                <span style={{
                  width: "24px", height: "24px", borderRadius: "50%", display: "inline-grid",
                  placeItems: "center", fontSize: "12px", fontWeight: 700, flex: "none",
                  background: "var(--brand-soft, #e3f4f1)", color: "var(--brand-d, #115e59)",
                }}>{currentIndex}</span>
              )}
              {title}
            </h4>
            <div className="list-group">
              {navItems.map((item, idx) => {
                const active = location.pathname === item.path;
                const done = isComplete(idx);
                return (
                  <div
                    key={idx}
                    onClick={() => navigate(item.path)}
                    className={`list-group-item list-group-item-action ${active ? "active" : ""}`}
                    style={{ cursor: "pointer" }}
                  >
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      {/* status icon */}
                      <span style={{
                        width: "22px", height: "22px", borderRadius: "50%", display: "inline-grid",
                        placeItems: "center", fontSize: "11px", fontWeight: 700, flex: "none",
                        background: done ? "var(--brand, #0f766e)" : active ? "var(--brand-soft, #e3f4f1)" : "#e8eeec",
                        color: done ? "#fff" : active ? "var(--brand-d, #115e59)" : "var(--muted, #5f716e)",
                      }}>
                        {done ? "✓" : idx === 0 ? "•" : idx}
                      </span>
                      <span style={{ fontWeight: active ? 700 : 500 }}>
                        {item.label}
                      </span>
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
